import { FormModal, ModalController, TextInput } from '@mi-front/ui';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';
import { DisplayableChunk } from '../../../../../../types';

interface ChunkSetLabelButtonProps {
  chunk: DisplayableChunk;
  onSetLabel: (label: string) => void;
}

/**
 * Button that opens a modal to edit the chunk label.
 * Uses MUI IconButton for consistent styling.
 */
export function ChunkSetLabelButton({ chunk, onSetLabel }: ChunkSetLabelButtonProps) {
  return (
    <ModalController
      trigger={(open) => (
        <Tooltip
          title={
            <FormattedMessage
              id="jointFragments.chunkLabel.edit"
              defaultMessage="Editar etiqueta"
            />
          }
        >
          <IconButton color="primary" size="small" onClick={open} sx={{ ml: 0.5 }}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    >
      {({ show, onHide }) => (
        <FormModal
          confirmCloseIfDirty={false}
          show={show}
          onHide={onHide}
          title={
            <>
              <EditIcon sx={{ mr: 1 }} />
              <FormattedMessage
                id="jointFragments.chunkLabel.modalTitle"
                defaultMessage="Establecer etiqueta de segmento"
              />
            </>
          }
          initialValues={{
            label: chunk.label,
          }}
          onSubmit={async ({ label }) => {
            onSetLabel(label?.trim() || '');
            onHide();
          }}
          validationSchema={yup.object().shape({
            label: yup.string(),
          })}
        >
          {(fp) => (
            <TextInput
              onChange={fp.handleChange}
              onBlur={fp.handleBlur}
              autoFocus
              required
              name="label"
              value={fp.values.label || ''}
              label={
                <FormattedMessage
                  id="jointFragments.chunkLabel.field"
                  defaultMessage="Nueva etiqueta"
                />
              }
            />
          )}
        </FormModal>
      )}
    </ModalController>
  );
}
